import { render } from "./FloorBox.vue?vue&type=template&id=65ba4616&scoped=true"
import script from "./FloorBox.vue?vue&type=script&lang=js"
export * from "./FloorBox.vue?vue&type=script&lang=js"

import "./FloorBox.vue?vue&type=style&index=0&id=65ba4616&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ba4616"]])

export default __exports__